import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLORS, DESIGN_TOKENS } from '@src/constants/design-tokens';

/**
 * フォーカスモード対応のスタイルコンポーネント
 * フォーカスモード状態に応じて適切なスタイルを適用
 */

// セクション
export const StyledSection = styled(Box)(({ theme }) => ({
  marginBottom: DESIGN_TOKENS.spacing.xl,
  padding: DESIGN_TOKENS.spacing.lg,
  backgroundColor: theme.palette.background.paper,
  // よりモダンで柔らかい印象に（Google Wallet風）
  borderRadius: DESIGN_TOKENS.borderRadius.xl,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow:
    theme.palette.mode === 'dark' ? COLORS.focusMode.card.shadow : DESIGN_TOKENS.shadows.sm,
  transition: DESIGN_TOKENS.animation.transitions.all,

  '&:hover': {
    boxShadow:
      theme.palette.mode === 'dark' ? COLORS.focusMode.card.shadow : DESIGN_TOKENS.shadows.md,
    transform: 'translateY(-2px)',
  },
}));

// フォーカスモード専用のスタイルコンポーネントはテーマ切替に統合したため不要
